<template>
  <div>
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>

        <span class="text-nowrap" />
      </template>
    </app-breadcrumb>
    <b-overlay
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card
        no-body
        class="mb-0"
      >
        <b-card-body>
          <b-col class="custom_width">
            <div>
              <b-form
                ref="form"
                class="repeater-form"
                @submit.prevent="repeateAgain"
              >
                <!-- Row Loop -->
                <b-row
                  v-for="(item, index) in items"
                  :id="item.id"
                  :key="item.id"
                  ref="row"
                >
                  <!-- Tên trường -->
                  <b-col md="4">
                    <validation-provider
                      #default="validationContext"
                      :name="$t('Tên trường là bắt buộc')"
                      rules="required"
                    >
                      <b-form-group
                        label="Tên trường"
                        label-for="item-name"
                      >
                        <b-form-input
                          id="item-name"
                          v-model="item.field"
                          type="text"
                          placeholder="Nhập tên trường"
                        />
                        <b-form-invalid-feedback :state="getValidationState(validationContext)">
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <!-- Cost -->
                  <b-col md="4">
                    <validation-provider
                      #default="validationContext"
                      :name="$t('Kiểu nhập')"
                      rules="required"
                    >
                      <b-form-group
                        label="Kiểu nhập"
                        label-for="type"
                      >
                        <b-form-select
                          v-model="item.type"
                          :options="options"
                          :reduce="val => val.value"
                          label="text"
                        />
                        <b-form-invalid-feedback :state="getValidationState(validationContext)">
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <!-- Remove Button -->
                  <b-col
                    lg="2"
                    md="3"
                    class="mb-50"
                  >
                    <b-button
                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                      v-b-tooltip.hover
                      variant="outline-danger"
                      class="mt-0 mt-md-2"
                      title="Xóa"
                      @click="removeItem(index, item.id)"
                    >
                      <feather-icon
                        icon="XIcon"
                        class="mr-25"
                      />
                      <span>Xóa</span>
                    </b-button>
                  </b-col>
                  <b-col cols="9">
                    <hr>
                  </b-col>
                </b-row>
              </b-form>
            </div>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              v-b-tooltip.hover
              variant="outline-info"
              title="Thêm trường"
              @click="repeateAgain"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Thêm trường</span>
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              v-b-tooltip.hover
              variant="outline-primary"
              title="Lưu"
              class="ml-1"
              @click="saveForm"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Lưu</span>
            </b-button>
          </b-col>
        </b-card-body></b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BCard,
  BOverlay,
  BFormRow,
  BCardBody,
  BFormSelect,
  BFormInvalidFeedback,
  VBTooltip,
} from 'bootstrap-vue';
import { heightTransition } from '@core/mixins/ui/transition';
import Ripple from 'vue-ripple-directive';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue';
import store from '@/store'
import { ValidationProvider } from 'vee-validate';
import formValidation from '@core/comp-functions/forms/form-validation'
import {
  ref, watch,
} from '@vue/composition-api'
import { useRouter, showToast } from '@core/utils/utils';
import {
  required, alphaNum, alphaNumDot, max, integer, positive,
} from '@validations';

export default {
  components: {
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BCard,
    BOverlay,
    BCardBody,
    AppBreadcrumb,
    BFormSelect,
    ValidationProvider,
    BFormInvalidFeedback,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      required,
      integer,
      alphaNum,
      alphaNumDot,
      max,
      positive,
      // items: [{
      //   id: 1,
      //   selected: 'male',
      //   selected1: 'designer',
      //   prevHeight: 0,
      // }],
      items: [{ field: '', type: 'text' }],
      // nextTodoId: 2,
      options: [
        { value: 'text', text: 'Ký tự' },
        { value: 'number', text: 'Số' },
        { value: 'date', text: 'Ngày tháng' },
      ],
      removeIds: [],
    };
  },
  mounted() {
    this.initTrHeight();
  },
  created() {
    window.addEventListener('resize', this.initTrHeight);
    this.getList();
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight);
  },
  methods: {
    repeateAgain() {
      this.items.push({
        // id: (this.nextTodoId += this.nextTodoId),

      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index, id) {
      if (this.items.length > 1) {
        this.items.splice(index, 1);
        this.trTrimHeight(this.$refs.row[0].offsetHeight);
        this.removeIds.push(id);
      } else {
        showToast('Không được xóa hết', { variant: 'error' });
      }
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },
    saveForm() {
      store.dispatch('studio/createFormSetting', { data: this.items, removeIds: this.removeIds })
        .then(response => {
          if (response.data.code === 200) {
            this.getList();
            this.removeIds = [];
            showToast(response.data.message, { variant: 'success' });
          }
        })
    },
    getList() {
      store.dispatch('studio/getFormSetting')
        .then(response => {
          if (response.data.code === 200) {
            const rslt = response.data.data;
            if (rslt.length > 0) {
              this.items = rslt;
            }
          }
        })
    },
  },

  setup(props, context) {
    const { route, router } = useRouter();
    const id = ref(route.value.params.id !== undefined ? route.value.params.id : 0);
    const layout = ref(route.value.name !== 'devices-edit' ? 'add' : 'edit');
    const loading = ref(!!id.value)
    const errorMessage = ref('')
    // const statusOptions = [
    //   { name: 'Hoạt động bình thường', id: 10 },
    //   { name: 'Đang sửa', id: 1 },
    // ];
    const defaultItemData = {
      name: '',

    }
    const itemData = ref(JSON.parse(JSON.stringify(defaultItemData)))

    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(defaultItemData))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetItemData)
    const onSubmit = () => {
      errorMessage.value = '';
      loading.value = true;
    }

    return {
      id,
      layout,
      errorMessage,
      loading,
      itemData,
      // devices,
      refFormObserver,
      getValidationState,
      resetForm,
      resetItemData,
      onSubmit,
    }
  },
};

</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}

.custom_width {
  margin: 0px auto;
  width: 70%;
}
</style>
